import * as numeral from 'numeral'

numeral.register('locale', 'it', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    currency: {
        symbol: '€'
    }
});

numeral.locale('it');

export {
    numeral
};



// WEBPACK FOOTER //
// ./src/common/global.js